<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { expenseService } from "../../../../services/managements/expenses/expense.service";
import { expenseCategoryService } from "../../../../services/managements/expenses/expensecategory.service";

import List from "../../../../components/list";
import Screen from "../../../../components/screen";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Expense List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        ...Screen.Alert,
        ...Screen.Locate,
        data: {},
        categoryData: {},
        fetchingStats: false,
        title: "Expense List",

        };
    },
    mounted() {
        
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
            this.fetchingStats = false;
            expenseService.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                this.data = response;
                
                
            });
            // next priorities data after list is done
            if(this.data){
                this.loadingCategory();
            }
        },

        loadingCategory: function() {
            expenseCategoryService.getList()
            .then(response => {
                this.categoryData = response;
            });
        },


        deleted: function(id) {
            expenseService.remove(id)
                .then(response => {
                // this.customerData = response;
                if(response.status == 200) {
                    this.$swal.fire({
                    title: i18n.t('general.confirm.deleted'),
                    text: i18n.t('general.confirm.success'),
                    icon: "success",
                    confirmButtonText: i18n.t('general.ok')
                    });
                }
            });
        },

        pageNavigate: function(param) {
        this.loadingData(param);
        },

        submitAdd: function() {
        this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-setting-service-type-add",
            });
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-expense-add'}" :title="'ការចំណាយ'" />
    <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[ 
            {name: 'amount', type: 'currency'},
            {name: 'cash_amount', type: 'currency'},
            {name: 'bank_amount', type: 'currency'},
            {name: 'cheque_amount', type: 'currency'},
            {name: 'expense_date', type: 'date'}
          ]"
          v-bind:fields="[ 
            `code: លេខកូដ`,
            `expense_date: កាលបរិច្ឆេទ`,
            `category_name: មុខចំណាយ`,
            `amount: ចំណាយសរុប`,
            `cash_amount: តាមសាច់ប្រាក់`,
            `bank_amount: តាមធនាគារ`,
            `cheque_amount: សែក`,

          ]"
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'manage-expense-edit'}"
          v-bind:filter="{
            search: ['manage_expenses.name','manage_expenses.code'],
            dropdown: [{
              title: 'manage.expense-category.text',
              field: 'manage_expenses.expense_category_id',
              data: this.categoryData.data,
            }]
          }"
          
    />      
  </Layout>
</template>